import React from 'react';
import { getRemotedbUrl } from '../../../lib/ep';

import ActionButton from '../../builder/ActionButton';

const FB = (props) => {
	if(props.url == undefined) return null;
	if(window.fb_share_enabled != undefined && !window.fb_share_enabled) return null;
	const share = props?.share ?? {};

	const click = () => {
		const linkable = props?.linkable ?? true;
		if(!linkable) return;

		if(props.fbtype == 'facebook_page' || true) {
			// xapussa gorda per evitar doble codificació de URL (verifiquem la codificació de la "/" (%2F)):
			const encoded_url = (props.url.indexOf("%2F") == -1) ? encodeURIComponent(props.url) : props.url;
			window.open(`https://www.facebook.com/sharer/sharer.php?u=${encoded_url}`, 'a', 'width=500,height=400,scrollbars=no');
		} else {
			var obj_share = {
				display:'popup',
				method:'feed',
				link:props.url,
				picture:props?.img ?? '',
			};

			if(props.from != undefined && props.from) {
				obj_share.from = props.from;
			}

			window.FB.ui(obj_share, (response) => {});
		}

		if(share.promotion_id != undefined) {
			$.post(getRemotedbUrl(`/users/sharebtn/${share.promotion_id}`), {
				network:1,
				page:share.page,
				type:share.type,
				uid:share?.user_id ?? null,
			});
		}
	};

	return (
		<ActionButton
			{...props}
			icon='ep-facebook is_facebook'
			onClick={() => click()}
		/>
	);
}

export default FB;